module.exports = __webpack_public_path__ + "static/me-6b763f1a2b036e2fa07dedae401e0825.jpg";